// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".search-icon-container[data-v-49fb0899]{height:32px;padding-left:24px;padding-right:16px;-ms-flex-wrap:nowrap;flex-wrap:nowrap}.clear-icon-container[data-v-49fb0899]{height:32px;padding:0;margin-right:16px;cursor:pointer}", ""]);
// Exports
module.exports = exports;
